<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button (click)="back()" text=""></ion-back-button>
    </ion-buttons>
    <ion-title>Vorschau</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div id="module-preview" [innerHTML]="snippet?.content| safeHtml"></div>
</ion-content>
